export enum EnrollmentStatus {
    NEEDS_SAFECHECK,
    NEEDS_MFA,
    ENROLLED,
    NOT_ENROLLED,
}
